import React from "react";
import "./OptionButton.css";

export default function OptionButton({
  label,
  selected = false,
  disabled = false,
  onClick,
  ariaLabel,
  title,
  className = "",
}) {
  return (
    <button
      type="button"
      className={`store-option-btn${selected ? " is-selected" : ""}${
        disabled ? " is-disabled" : ""
      }${className ? ` ${className}` : ""}`}
      onClick={disabled ? undefined : onClick}
      aria-pressed={selected}
      aria-label={ariaLabel || label}
      title={title || label}
      disabled={disabled}
    >
      {label}
    </button>
  );
}

